/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ObservableItemResponse
 */
export interface ObservableItemResponse {
    /**
     * 
     * @type {number}
     * @memberof ObservableItemResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservableItemResponse
     */
    dataTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservableItemResponse
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservableItemResponse
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservableItemResponse
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ObservableItemResponse
     */
    isCollection?: boolean;
}

/**
 * Check if a given object implements the ObservableItemResponse interface.
 */
export function instanceOfObservableItemResponse(value: object): value is ObservableItemResponse {
    return true;
}

export function ObservableItemResponseFromJSON(json: any): ObservableItemResponse {
    return ObservableItemResponseFromJSONTyped(json, false);
}

export function ObservableItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObservableItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'label': json['label'] == null ? undefined : json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'isCollection': json['isCollection'] == null ? undefined : json['isCollection'],
    };
}

export function ObservableItemResponseToJSON(json: any): ObservableItemResponse {
    return ObservableItemResponseToJSONTyped(json, false);
}

export function ObservableItemResponseToJSONTyped(value?: ObservableItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'identifier': value['identifier'],
        'label': value['label'],
        'description': value['description'],
        'isCollection': value['isCollection'],
    };
}

